import MainLayout from "../../../layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import DeleteModal from "../../../components/modal/delete-modal";
import { TextView } from "../../../components/view-form-components/text-view";
import { useEffect } from "react";
import CommentsComponent from "../../../components/comments/comments";
import FileCommentComponent from "../../../components/comments/file-comment";
import { api } from "../../../redux/apis/api";
import { useRole } from "../../../context/role/RoleContext";

const ViewRoles = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useRole();
  const permission = state?.role?.employee;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/ffadmin/role/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    api
      .post(`/ffadmin/role/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/admin/roles/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const modelLabels = {
    employee: "Employee",
    company: "Company",
    lead: "Lead",
    customer: "Customer",
    product: "Product",
    order: "Order",
    marketing_material: "Marketing Material",
    employee_live_tracking: "Employee Live Tracking",
  };

  const datapermissions = {
    Module: {
      read: "read",
      write: "write",
      all_data: "all_data",
      only_associated: "only_associated",
    },
    employee: {
      read: data?.employee?.read === true ? true : false,
      write: data?.employee?.write === true ? true : false,
      all_data: data?.employee?.all_data === true ? true : false,
      only_associated: data?.employee?.only_associated === true ? true : false,
    },
    company: data?.company ?? {
      read: data?.company?.read === true ? true : false,
      write: data?.company?.write === true ? true : false,
      all_data: data?.company?.all_data === true ? true : false,
      only_associated: data?.company?.only_associated === true ? true : false,
    },
    lead: data?.lead ?? {
      read: data?.lead?.read === true ? true : false,
      write: data?.lead?.write === true ? true : false,
      all_data: data?.lead?.all_data === true ? true : false,
      only_associated: data?.lead?.only_associated === true ? true : false,
    },
    customer: {
      read: data?.customer?.read === true ? true : false,
      write: data?.customer?.write === true ? true : false,
      all_data: data?.customer?.all_data === true ? true : false,
      only_associated: data?.customer?.only_associated === true ? true : false,
    },
    product: {
      read: data?.product?.read === true ? true : false,
      write: data?.product?.write === true ? true : false,
      all_data: data?.product?.all_data === true ? true : false,
      only_associated: data?.product?.only_associated === true ? true : false,
    },
    order: {
      read: data?.order?.read === true ? true : false,
      write: data?.order?.write === true ? true : false,
      all_data: data?.order?.all_data === true ? true : false,
      only_associated: data?.order?.only_associated === true ? true : false,
    },
    marketing_material: {
      read: data?.marketing_material?.read === true ? true : false,
      write: data?.marketing_material?.write === true ? true : false,
      all_data: data?.marketing_material?.all_data === true ? true : false,
      only_associated:
        data?.marketing_material?.only_associated === true ? true : false,
    },
    employee_live_tracking: {
      read: data?.employee_live_tracking?.read === true ? true : false,
      write: data?.employee_live_tracking?.write === true ? true : false,
      all_data: data?.employee_live_tracking?.all_data === true ? true : false,
      only_associated:
        data?.employee_live_tracking?.only_associated === true ? true : false,
    },
    lead_activity: {
      read: data?.lead_activity?.read === true ? true : false,
      write: data?.lead_activity?.write === true ? true : false,
      all_data: data?.lead_activity?.all_data === true ? true : false,
      only_associated:
        data?.lead_activity?.only_associated === true ? true : false,
    },
    customer_activity: {
      read: data?.customer_activity?.read === true ? true : false,
      write: data?.customer_activity?.write === true ? true : false,
      all_data: data?.customer_activity?.all_data === true ? true : false,
      only_associated:
        data?.customer_activity?.only_associated === true ? true : false,
    },
    employee_request: {
      read: data?.employee_request?.read === true ? true : false,
      write: data?.employee_request?.write === true ? true : false,
      all_data: data?.employee_request?.all_data === true ? true : false,
      only_associated:
        data?.employee_request?.only_associated === true ? true : false,
    },
    payment: {
      read: data?.payment?.read === true ? true : false,
      write: data?.payment?.write === true ? true : false,
      all_data: data?.payment?.all_data === true ? true : false,
      only_associated: data?.payment?.only_associated === true ? true : false,
    },
    settings: {
      read: data?.settings?.read === true ? true : false,
      write: data?.settings?.write === true ? true : false,
      all_data: data?.settings?.all_data === true ? true : false,
      only_associated: data?.settings?.only_associated === true ? true : false,
    },
    tile_layer: {
      read: data?.tile_layer?.read === true ? true : false,
      write: data?.tile_layer?.write === true ? true : false,
      all_data: data?.tile_layer?.all_data === true ? true : false,
      only_associated:
        data?.tile_layer?.only_associated === true ? true : false,
    },
    expense: {
      read: data?.expense?.read === true ? true : false,
      write: data?.expense?.write === true ? true : false,
      all_data: data?.expense?.all_data === true ? true : false,
      only_associated: data?.expense?.only_associated === true ? true : false,
    },
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <h2 className="text-xl font-semibold capitalize">
            Admin roles - view
          </h2>
          <div className="flex gap-3 items-center">
            {permission?.write && (
              <Link
                className="px-4 py-2 bg-blue-600 text-white rounded"
                to={`/admin/roles/edit/${params?.id}`}
              >
                edit
              </Link>
            )}
            {permission?.write && (
              <button
                onClick={() => {
                  setdeleteModalShow(true);
                }}
                className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
              >
                Delete
              </button>
            )}
          </div>
        </div>
        <section className="w-full max-w-[40rem]">
          <div className="px-2">
            <TextView label={"Name"} value={data?.name} />
          </div>

          <div className="px-2">
            <TextView label={"type"} value={data?.type} />
          </div>

          <div>
            {Object.keys(datapermissions).map((modelKey) => (
              <div key={modelKey} className="flex justify-between">
                <div className="p-2 w-full max-w-[16rem]">
                  {(modelLabels[modelKey] || modelKey) === "Module" ? (
                    <p className="text-nowrap pb-2 text-lightGreyText">
                      Module Name
                    </p>
                  ) : (
                    modelLabels[modelKey] || modelKey
                  )}
                </div>

                <div className="p-2 w-full max-w-[5rem]">
                  {datapermissions[modelKey].read === "read" ? (
                    <p className="text-nowrap pb-2 text-lightGreyText">Read</p>
                  ) : (
                    <input
                      disabled={datapermissions[modelKey].write}
                      type="checkbox"
                      checked={datapermissions[modelKey].read}
                    />
                  )}
                </div>

                <div className="p-2  w-full max-w-[5rem]">
                  {datapermissions[modelKey].write === "write" ? (
                    <p className="text-nowrap pb-2 text-lightGreyText">write</p>
                  ) : (
                    <input
                      type="checkbox"
                      checked={datapermissions[modelKey].write}
                    />
                  )}
                </div>
                <div className="p-2  w-full max-w-[5rem]">
                  {datapermissions[modelKey].all_data === "all_data" ? (
                    <p className="text-nowrap pb-2 text-lightGreyText">
                      All data
                    </p>
                  ) : (
                    <input
                      type="checkbox"
                      checked={datapermissions[modelKey].all_data}
                    />
                  )}
                </div>

                <div className="p-2  w-full max-w-[8rem]">
                  {datapermissions[modelKey].only_associated ===
                  "only_associated" ? (
                    <p className="text-nowrap pb-2 text-lightGreyText">
                      only associated
                    </p>
                  ) : (
                    <input
                      type="checkbox"
                      checked={datapermissions[modelKey].only_associated}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>

          <CommentsComponent tableName={"Role"} viewId={params?.id} />
          <FileCommentComponent tableName={"Role"} viewId={params?.id} />
        </section>
      </section>
    </MainLayout>
  );
};

export default ViewRoles;
